import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Context from '../../../utils/context';

import styles from './v2.module.css';

const CheckIcon = () => (
  <svg className={styles.check} viewBox='0 0 12 12' fill='none' aria-hidden='true'>
    <path d='M2 6.5L4.75 9L10 3.5' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

export default function AcceptPrivacyModalV2() {
  const location = useLocation();
  const context = useContext(Context);
  const [show, setShow] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [acceptedPrivacy, setAcceptedPrivacy] = useState(false);
  const titleId = useRef(`accept-privacy-title-${Math.random().toString(36).slice(2, 9)}`);

  useEffect(() => {
    if (
      context.auth.isLoggedIn() &&
      !context.auth.getCurrentUser().accepted_privacy &&
      !context.auth.isImpersonating() &&
      !context.auth.isSuperUser()
    ) {
      setShow(true);
    }
  }, [location]);

  const canContinue = acceptedTerms && acceptedPrivacy;

  const handleContinue = () => {
    if (!canContinue) return;
    setShow(false);
    context.auth.userUpdate({ accepted_privacy: true });
  };

  if (!show) return null;

  return (
    <div className={styles.backdrop} role='dialog' aria-modal='true' aria-labelledby={titleId.current}>
      <div className={styles.dialog}>
        <div className={styles.header}>
          <h2 id={titleId.current} className={styles.title}>
            Changes to our Terms of Use
          </h2>
        </div>

        <div className={styles.body}>
          <p>
            PatientPartner has updated the{' '}
            <Link to='/terms' target='_blank' className={styles.link}>
              Terms of Service
            </Link>{' '}
            and{' '}
            <Link to='/privacy' target='_blank' className={styles.link}>
              Privacy Policy and Authorizations
            </Link>
            . Please read and agree to the updated policies to continue.
          </p>

          <label className={acceptedTerms ? `${styles.checkbox_row} ${styles.checked}` : styles.checkbox_row}>
            <input
              type='checkbox'
              className={styles.input}
              checked={acceptedTerms}
              onChange={() => setAcceptedTerms((value) => !value)}
            />
            <span className={styles.checkbox}>
              <CheckIcon />
            </span>
            <span className={styles.checkbox_text}>
              I agree to the{' '}
              <Link to='/terms' target='_blank' className={styles.link}>
                Terms of Service
              </Link>
              .
            </span>
          </label>

          <label className={acceptedPrivacy ? `${styles.checkbox_row} ${styles.checked}` : styles.checkbox_row}>
            <input
              type='checkbox'
              className={styles.input}
              checked={acceptedPrivacy}
              onChange={() => setAcceptedPrivacy((value) => !value)}
            />
            <span className={styles.checkbox}>
              <CheckIcon />
            </span>
            <span className={styles.checkbox_text}>
              I agree to the{' '}
              <Link to='/privacy' target='_blank' className={styles.link}>
                Privacy Policy and Authorization
              </Link>
              .
            </span>
          </label>
        </div>

        <div className={styles.footer}>
          <button type='button' className={styles.continue_btn} onClick={handleContinue} disabled={!canContinue}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
